import { SplitPanel } from '@infotech-soe/erp-ui-kit';
import React, { useMemo } from 'react';

import { TPaneSign, TTreeId } from '../../../models/role-privs/RolePrivsData';
import PrivsTreeContainer from '../dm-tree/PrivsTreeContainer';

import RolePrivsListActionContainer from './RolePrivsListActionContainer';
import { usePrivsPanelStyles } from './styles';

interface TreeWithActionsProps {
  treeId?: TTreeId;
  pane: TPaneSign;
  isCategoryTree?: boolean;
  withoutActions?: boolean;
}

const TreeWithActions: React.FC<TreeWithActionsProps> = ({
  treeId,
  pane,
  isCategoryTree,
  withoutActions,
}) => {
  const classes = usePrivsPanelStyles();
  const Tree = useMemo(
    () =>
      treeId ? (
        <PrivsTreeContainer
          className={classes.privsPanel}
          treeId={treeId}
          pane={pane}
          isCategoryTree={isCategoryTree}
        />
      ) : null,
    [treeId, classes.privsPanel, pane, isCategoryTree]
  );

  if (!treeId) {
    return null;
  }
  return withoutActions ? (
    Tree
  ) : (
    <SplitPanel defaultSize={isCategoryTree ? 50 : 77}>
      {Tree}
      <RolePrivsListActionContainer
        className={classes.privsPanel}
        treeId={treeId}
        pane={pane}
        isCategoryTree={isCategoryTree}
      />
    </SplitPanel>
  );
};

export default React.memo(TreeWithActions);
